export const MFA_RE_ENROLLMENT_GUIDE_URL =
  'assets/documents/CRD_MFA_Re-Enrollment_Troubleshooting_Guide.pdf';

export const MFA_RE_ENROLLMENT_GUIDE_URLS = {
  microsoftAuthenticator: 'assets/documents/CRD_MFA_Re-Enrollment_Microsoft_Authenticator.pdf',
  googleAuthenticator: MFA_RE_ENROLLMENT_GUIDE_URL,
  auth0Guardian: 'assets/documents/CRD_MFA_Re-Enrollment_Auth0_Guardian.pdf',
} as const;

export const MFA_SETUP_GUIDE_URLS = {
  microsoftAuthenticator: 'assets/documents/CRD_MFA_Setup_Microsoft_Authenticator.pdf',
  googleAuthenticator: 'assets/documents/CRD_MFA_Setup_Google_Authenticator.pdf',
  auth0Guardian: 'assets/documents/CRD_MFA_Setup_Auth0_Guardian.pdf',
} as const;
